// Resolution feedback (architecture plan §7.6, §11.6; build plan P11). "Did this resolve the
// issue?" Yes records, comments on the card, and tags it — no state change; an operator
// closes. No requires a comment, reopens both sides, and re-triages with the prior run and the
// new words as context.

import { z } from "zod";
import { RequestStatusSchema } from "./enums";

export const FEEDBACK_OUTCOMES = ["fixed", "not_fixed"] as const;
export const FeedbackOutcomeSchema = z.enum(FEEDBACK_OUTCOMES);
export type FeedbackOutcome = z.infer<typeof FeedbackOutcomeSchema>;

export const FeedbackBodySchema = z
  .object({
    outcome: FeedbackOutcomeSchema,
    /** Required when not fixed: what remains wrong. Sanitized like any intake text. */
    comment: z.string().trim().max(20000).optional(),
  })
  .strict()
  .refine((b) => b.outcome === "fixed" || (b.comment !== undefined && b.comment.length >= 10), {
    message: "tell us what still is not working (at least 10 characters)",
    path: ["comment"],
  });
export type FeedbackBody = z.infer<typeof FeedbackBodySchema>;

export const FeedbackResponseSchema = z.object({
  id: z.uuid(),
  outcome: FeedbackOutcomeSchema,
  status: RequestStatusSchema,
  /** True when a credential-shaped value was removed from the comment. */
  redacted: z.boolean(),
});
export type FeedbackResponse = z.infer<typeof FeedbackResponseSchema>;
